module.exports = __webpack_public_path__ + "img/Image2.4cccb867.jpg";